import React from "react";
import ProductForm from "./ProductForm";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const CreateProduct = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <ProductForm />
  </DashboardLayout>
);

export default CreateProduct;
